import React, { useState, useContext, useEffect, useRef } from 'react';
import axiosConfig from '../../configs/axios.config';
import axios from 'axios'
import { Input, Button, Space, Form, Row, Col, InputNumber } from 'antd';

const { Search } = Input;

const InventoryBarcodeExport = () => {
    const inputRef = useRef(null);
    const inputNoteRef = useRef(null);

    const [form] = Form.useForm();
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 7 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
        },
    };
    const [noti, setNoti] = useState('')
    const [BarCodeSearch, setBarCodeSearch] = useState('')

    const [found, setfound] = useState({
        ItemCode: '',
        BarCode: '',
        Qty: 0,
        NewItemCode: '',
        ChungNhan: '',
        DinhLuong: '',
        LoaiGiay: '',
        NhanHang: '',
        ChieuRong: 0,
        QCChieuDai: 0,
        Note: '',
        S1no: ''
    })

    const onSearch = async (value) => {
        // let FSearch = loadData.find(element => element.BarCode === value)
        const FSearch = await axios.create(axiosConfig).post('api/inventory/GetInventory', '{"BarCode":"' + value + '"}')

        if (FSearch.data.result.length > 0) {
            FSearch.data.result[0].Qty = 0
            setNoti('')
            setfound(FSearch.data.result[0]);
            // setfound({ ...found, Qty: 0 })
        }
        else {
            setfound({
                ItemCode: '',
                BarCode: value,
                Qty: 0,
                NewItemCode: '',
                ChungNhan: '',
                DinhLuong: '',
                LoaiGiay: '',
                NhanHang: '',
                ChieuRong: 0,
                QCChieuDai: 0,
                Note: '',
                S1no: ''
            })
            setNoti('Không tim thấy thông tin')
        }
        const response = await axios.create(axiosConfig).post('api/inventory/getCheckBarCodeExport', '{"BarCode":"' + value + '"}')
        if (response.data.success && response.data.result.length > 0) {
            setNoti('BarCode đã xuất: ' + response.data.result[0].NewItemCode + ' Còn lại: ' + response.data.result[0].Qty)

        }


    };
    const onFinish = async (values) => {
        inputRef.current.focus({
            cursor: 'all',
        });
        if (found.BarCode === '')
            setNoti('Vui lòng nhập barcode')
        else {
            setNoti('')
            console.log('Received values of form: ', found);
            const response = await axios.create(axiosConfig).post('api/inventory/PostInsertInventoryExport', found)
            if (response.data.success) {
                setfound({
                    ItemCode: '',
                    BarCode: '',
                    Qty: 0,
                    NewItemCode: '',
                    ChungNhan: '',
                    DinhLuong: '',
                    LoaiGiay: '',
                    NhanHang: '',
                    ChieuRong: 0,
                    QCChieuDai: 0,
                    Note: '',
                    S1no: ''
                })
                setBarCodeSearch('')
            }

        }


    };
    const onFormChange = event => {
        if (found)
            setfound({ ...found, [event.target.name]: event.target.value })
    }
    const onNumChange = name => value => {
        if (found)
            setfound({ ...found, [name]: value })
    }
    const onSearchChange = (e) => {
        setBarCodeSearch(e.target.value)
    }
    const sharedProps = {
        ref: inputRef,
    };
    return (
        <>
            <div className='custom-searchtext'>
                <Search
                    placeholder="Tìm kiếm..."
                    allowClear
                    enterButton="Tìm kiếm"
                    size="large"
                    onSearch={onSearch}
                    onChange={onSearchChange}
                    value={BarCodeSearch ? BarCodeSearch : ''}
                    {...sharedProps}
                />
            </div>
            <h3 style={{ color: 'red' }}>{noti}</h3>
            <Form {...formItemLayout} form={form} name="advanced_search" layout="horizontal" className="ant-advanced-search-form" size={'small'} onFinish={onFinish} >

                <Row gutter={22}>
                    <Col span={7} key={0}>
                        <Form.Item label={`Mã hàng cũ`} disabled >
                            {found ? found.ItemCode : ''}
                        </Form.Item>
                    </Col>
                    <Col span={7} key={1}>
                        <Form.Item label={`Mã hàng mới`} disabled >
                            {found ? found.NewItemCode : ''}
                        </Form.Item>
                    </Col>
                    <Col span={7} key={2}>
                        <Form.Item label={`Chứng nhận`} disabled >
                            {found ? found.ChungNhan : ''}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={22}>
                    <Col span={7} key={3}>
                        <Form.Item label={`Loại giấy`} disabled >
                            {found ? found.LoaiGiay : ''}

                        </Form.Item>
                    </Col>
                    <Col span={7} key={4}>
                        <Form.Item label={`Nhãn hàng`} disabled >
                            {found ? found.NhanHang : ''}
                        </Form.Item>
                    </Col>
                    <Col span={7} key={5}>
                        <Form.Item label={`Định lượng`} disabled >
                            {found ? found.DinhLuong : ''}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={22}>
                    <Col span={7} key={3}>
                        <Form.Item label={`Chiều dộng`} disabled >
                            {found ? found.ChieuRong : ''}
                        </Form.Item>
                    </Col>
                    <Col span={7} key={4}>
                        <Form.Item label={`Chiều dài`} disabled >
                            {found ? found.QCChieuDai : ''}
                        </Form.Item>
                    </Col>
                    <Col span={7} key={5}>
                        <Form.Item  label={`Khối lượng`} >
                            <InputNumber value={found ? found.Qty : 0} onChange={onNumChange("Qty")} />
                            <br />
                        </Form.Item>
                    </Col>
                    {/* <Col span={7} key={5}>
                        <Form.Item label={`SL còn lại`} >
                            <InputNumber name={`Qty`} value={0} onChange={onFormChange} />
                            <br />
                        </Form.Item>
                    </Col> */}
                </Row>
                <Row gutter={22}>
                    <Col span={7} key={3}>
                        <Form.Item label={`Số lệnh`}  >
                            <Input name={`S1no`} value={found ? found.S1no : ''} showCount maxLength={100} onChange={onFormChange} />
                            <br />
                        </Form.Item>
                    </Col>
                    <Col span={14} key={4}>
                        <Form.Item label={`Ghi chú`} >
                            <Input name={`Note`} value={found ? found.Note : ''} showCount maxLength={100} onChange={onFormChange} />
                            <br />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={21} style={{ display: 'flex', justifyContent: 'right', }}>
                        <Button type="primary" htmlType="submit" >
                            Xuất kho
                        </Button>
                    </Col>
                </Row>

            </Form>
        </>
    );
};



export default InventoryBarcodeExport;